import store from '@/store';

const accessRules = {
    // pages
    payslipsPage: ['admin', 'manager', 'client'],    
    dashboardsPage: ['admin'],
    transactionsPage: ['admin', 'manager'],
    settlementsPage: ['admin', 'manager'],
    balancesPage: ['admin', 'manager'],

    // permissions
    payslipDowloads: ['admin', 'manager', 'client'],
    gettingPersonList: ['admin', 'manager'],
    gettingPersonListForPayslips: ['admin', 'manager'], // TODO: выпилить
    gettingObjectListForPerson: ['admin', 'manager'],
    dealParams: ['admin', 'manager', 'client'],
  };
  
  export function getAllowedRoles(elementKey) {
    return accessRules[elementKey] || [];
  }
    
  export function isPermitionAllowedForRole(elementKey, userRole) {
    return getAllowedRoles(elementKey).includes(userRole);
  }

  export function isPermitionAllowed(elementKey, _userRole) {
    const userRole = store.getters['user/getRoleCurentUser'];
    return getAllowedRoles(elementKey).includes(userRole);
  }